// Angular
import { Injectable } from '@angular/core';

// Services
import { ApiService } from './api.service';
import { CacheService } from './../utils/cache.service';

// Resources
import { Resource } from './base/resource';

// Helpers
import { isViewportMobile, isUndefined } from '../../lib/helpers/utils';

// Store
import { AppState } from '../../../store/index';
import { Store } from '@ngrx/store';

// Actions
import * as RouterActions from '../../../store/router/router.actions';

declare var printJS: any;

@Injectable()
export class UtilsService extends Resource {
    constructor(cache: CacheService, api: ApiService, private store: Store<AppState>) {
        super(cache, api, 'utils');
    }

    goToLogin() {
        this.store.dispatch(
            new RouterActions.Go({
                path: ['login'],
            })
        );
    }

    goToMainProducts() {
        this.store.dispatch(
            new RouterActions.Go({
                path: ['dashboard/products/main'],
            })
        );
    }

    // openModalNewOrder(user: User) {
    //     const options = {
    //         class: 'uni-modal--adaptive',
    //         type: 'full',
    //         size: 'large',
    //         hideHeader: true,
    //         user: user,
    //     };
    //     this.modalService.createModal(OrdersNewComponent, options).subscribe(
    //         (param) => {
    //             console.log('aceptado: ', param);
    //         },
    //         (error) => {
    //             console.log('cancelado: ', error);
    //         }
    //     );
    // }

    goToScrollHard(anchor: string, offset?: number): void {
        const el = document.getElementById(anchor);
        if (el) {
            let position = el.getBoundingClientRect();
            let top = position.top;
            let offSet = typeof offset !== 'undefined' ? offset : 0;

            window.scrollTo(0, top + offSet);
        }
    }

    goToScroll(anchor: string): void {
        const el = document.getElementById(anchor);
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    goTopScroll(idElement: string) {
        const el = document.getElementById(idElement);
        if (el) {
            el.scrollTop = 0;
        }
    }

    goTopBodyScroll() {
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }

    elementGoToScroll(idElement: string, pos: number) {
        const el = document.getElementById(idElement);
        if (el) {
            // console.log("navegando a pos: ", pos);
            el.scrollTop = pos;
        }
    }

    printPdf(url: string) {
        // TODO: PRUEBAS (QUITAR)
        url = url || 'assets/demo.pdf';

        printJS(url);
    }

    downloadPDF(url: string): boolean {
        const popup = window.open(url, '_blank');
        if (popup == null || isUndefined(open)) {
            return false;
        }
        return true;
    }

    downloadExcel(url: string) {
        window.open(url, '_blank').opener = null;
    }

    downloadImg(url: string) {
        window.open(url, '_blank').opener = null;
    }

    openExternalURL(url: string) {
        window.open(url, '_blank').opener = null;
    }

    isViewportMobile() {
        return isViewportMobile();
    }
}
